<template>
  <form @submit.prevent="submitForm">
    <div class="form">
      <div class="field-country-tel" :class="{'error': errors.phone && errors.phone.length}">
        <v-select v-model="userData.country" :options="countries.map(x => ({id: x.id, label: x.alpha}))"
                  :reduce="x => x.id" :searchable="false" :clearable="false">
          <template #open-indicator="{ attributes }">
            <span v-bind="attributes"><i class="svg-icon arrow"></i></span>
          </template>
        </v-select>
        <div class="field">
          <label class="error-label" v-if="errors.phone && errors.phone.length && !userData.phone">{{ errors.phone[0] }}</label>
          <input-phone v-model="userData.phone" :value="userData.phone" :mask="phoneMask"
                       @clear-errors="clearErrors('phone')" :text="$t('country_phone')" />
          <label v-if="errors.phone && errors.phone.length && userData.phone">{{ errors.phone[0] }}</label>
          <label v-else-if="errors.phone && errors.phone.length && !userData.phone">{{ $t('country_phone') }}</label>
          <label v-else>{{ $t('country_phone') }}</label>
        </div>
      </div>

      <field-text v-model="userData.inn" :value="userData.inn"
                  :text="!selectedCountry || selectedCountry.inn_check ? $t('inn') : $t('inn_any_country')"
                  :errors="errors.inn" @clear-errors="clearErrors('inn')" />

      <field-text v-model="userData.company_name" :value="userData.company_name" :text="$t('company_name')"
                  :disabled="innCheckEnabled" :errors="errors.company_name" @clear-errors="clearErrors('company_name')" />

        <div class="field-v-select field-city" :class="{'error': errors.city && errors.city.length}">
        <label v-if="errors.city && errors.city.length && !userData.city" class="error-label">
          {{ errors.city[0] }}
        </label>
        <v-select ref="city" v-model="userData.city" @search="searchCity"
                  :options="cities" :clearable="false" :filterable="false"
                  @option:selected="clearErrors('city')" @search:blur="onBlurCity"
                  :class="{'selected': !!userData.city || citySearchTerm}"
                  :clearSearchOnBlur="() => false" :clearSearchOnSelect="false">
          <template #open-indicator="{ attributes }">
            <span></span>
          </template>
          <template #no-options="{search, searching, loading}">
            <span></span>
          </template>
        </v-select>
        <label v-if="errors.city && errors.city.length && userData.city">{{ errors.city[0] }}</label>
        <label v-else-if="errors.city && errors.city.length && !userData.city">{{ $t('city') }}</label>
        <label v-else>{{ $t('city') }}</label>
      </div>

      <div class="field-v-select" :class="{'error': errors.main_distributor && errors.main_distributor.length}">
        <label v-if="errors.main_distributor && errors.main_distributor.length && !userData.main_distributor" class="error-label">
          {{ errors.main_distributor[0] }}
        </label>
        <v-select v-model="userData.main_distributor"
                  :options="distributors.map(x => ({id: x.id, label: x.profile?.company_name + formatCity(x)}))"
                  :reduce="x => x.id" :searchable="false" :clearable="false"
                  @option:selected="clearErrors('main_distributor')"
                  :class="{'selected': !!userData.main_distributor}">
          <template #open-indicator="{ attributes }">
            <span v-bind="attributes"><i class="svg-icon arrow"></i></span>
          </template>
          <template #no-options="{search, searching, loading}">
            <span></span>
          </template>
        </v-select>
        <label v-if="errors.main_distributor && errors.main_distributor.length && userData.main_distributor">{{ errors.main_distributor[0] }}</label>
        <label v-else-if="errors.main_distributor && errors.main_distributor.length && !userData.main_distributor">{{ $t('main_distributor') }}</label>
        <label v-else>{{ $t('main_distributor') }}</label>
      </div>

      <div class="field-v-select" :class="{'error': errors.main_distributor_address && errors.main_distributor_address.length}">
        <label v-if="errors.main_distributor_address && errors.main_distributor_address.length && !userData.main_distributor_address" class="error-label">
          {{ errors.main_distributor_address[0] }}
        </label>
        <v-select v-model="userData.main_distributor_address"
                  :options="branchaddresses_filtered"
                  :reduce="x => x.id"
                  :searchable="false"
                  :clearable="false"
                  :disabled="!userData.main_distributor"
                  :class="{'selected': !!userData.main_distributor_address}"
                  @option:selected="clearErrors('main_distributor_address')"
        >
          <template #open-indicator="{ attributes }">
            <span v-bind="attributes"><i class="svg-icon arrow"></i></span>
          </template>
          <template #no-options="{search, searching, loading}">
            <span></span>
          </template>
        </v-select>
        <label v-if="errors.main_distributor_address && errors.main_distributor_address.length && userData.main_distributor_address">{{ errors.main_distributor_address[0] }}</label>
        <label v-else-if="errors.main_distributor_address && errors.main_distributor_address.length && !userData.main_distributor_address">{{ $t('main_distributor_address') }}</label>
        <label v-else>{{ $t('main_distributor_address') }}</label>
      </div>

      <field-text v-model="userData.email" :value="userData.email" text="Email"
                  :errors="errors.email" @clear-errors="clearErrors('email')" autocomplete="UserName" />

      <field-text v-model="userData.first_name" :value="userData.first_name" :text="$t('first_name')"
                  :errors="errors.first_name" @clear-errors="clearErrors('first_name')" />

      <field-text v-model="userData.last_name" :value="userData.last_name" :text="$t('last_name')"
                  :errors="errors.last_name" @clear-errors="clearErrors('last_name')" />

      <field-password v-model="userData.password" :value="userData.password" :text="$t('set_password')"
                      :errors="errors.password" @clear-errors="clearErrors('password')" :show-icon="true"
                      :show-password="showPassword" @changeTypeField="changeTypeField($event)"
      />

      <field-password v-model="userData.confirm_password" :value="userData.confirm_password" :text="$t('confirm_password')"
                      :errors="errors.confirm_password" @clear-errors="clearErrors('confirm_password')"
                      :show-password="showPassword"
      />
    </div>
    <div class="captcha-links">
      <span class="error-captcha" v-if="errors.recaptcha && errors.recaptcha.length">
        {{ $t('captcha_error') }}
      </span>
      <site-text-block type="form_submit" class="submit-text" />
      <button type="submit" :disabled="pendingRegister">{{ $t('continue')
        }}<span v-if="pendingRegister" class="svg-icon loader"></span></button>
    </div>
  </form>
</template>

<script>
import vSelect from 'vue-select';
import {Country} from '@/models/country';

import FieldPassword from '@/components/controls/field-password';
import FieldText from '@/components/controls/field-text';
import InputPhone from '@/components/controls/input-phone';
import SiteTextBlock from '@/components/blocks/site-text-block';

export default {
  components: {
    FieldPassword,
    FieldText,
    InputPhone,
    SiteTextBlock,
    vSelect,
  },
  data() {
    return {
      countries: [],
      distributors: [],
      branchaddresses: [],
      branchaddresses_filtered: [],
      cities: [],
      citySearchTerm: null,
      userData: {
        mode: 'retailer',
        country: null,
        phone: null,
        inn: null,
        city: null,
        main_distributor: null,
        main_distributor_address: null,
        company_name: null,
        first_name: null,
        last_name: null,
        email: null,
        password: null,
        confirm_password: null,
        recaptcha: null,
      },
      errors: {},
      showPassword: false,
      pendingRegister: false,
    }
  },
  watch: {
    'userData.main_distributor'() {
      this.userData.main_distributor_address = null;
      this.branchaddresses_filtered = this.branchaddresses.filter(
        x => x.user_id === this.userData.main_distributor
      ).map(
        x => ({id: x.id, label: x.name})
      )
      this.userData.main_distributor_address = this.branchaddresses_filtered.length === 1 ?
        this.branchaddresses_filtered[0].id :
        null;
    },
    'userData.inn'() {
      this.checkInn();
    },
    'userData.city'(value) {
      if (this.$refs.city) {
        this.$refs.city.search = value;
        this.$nextTick(() => {
          this.$refs.city.open = false;
          this.$refs.city.searchEl.blur();
        });
      }
    },
    phoneMask() {
      this.userData.phone = null;
    },
    innCheckEnabled(value) {
      if (value) {
        this.userData.company_name = null;
        this.checkInn();
      }
    },
  },
  computed: {
    selectedCountry() {
      return this.countries.find(x => x.id === this.userData.country);
    },
    phoneMask() {
      return this.selectedCountry ? this.selectedCountry.phone_mask : '';
    },
    innCheckEnabled() {
      return !this.selectedCountry || this.selectedCountry.inn_check;
    },
  },
  async fetch() {
    [this.countries, this.distributors, this.branchaddresses] = await Promise.all([
      Country.config({count_loading: true}).get(),
      this.$axios.$get('/loyalpro/users/distributors/'),
      this.$axios.$get('/user/branch/addresses/'),
    ]);
    this.branchaddresses = this.branchaddresses?.companies;
    if (this.countries.length) {
      this.userData.country = this.countries[0].id;
    }
  },
  beforeDestroy() {
    this.$recaptcha.destroy();
  },
  methods: {
    formatCity(x){
      if (x.profile?.city){
        return ' ('+x.profile?.city+')'
      }
      return ''
    },
    clearErrors(field) {
      this.errors[field] = [];
    },
    async submitForm() {
      try {
        if(!this.pendingRegister) {
          this.pendingRegister = true;
          this.userData.recaptcha = await this.$recaptcha.execute('register');
          await this.$axios.$post('/user/registration/', this.userData);
          this.pendingRegister = false;
          this.$emit('registration-completed');
          this.$emit('set-email', this.userData.email);
        }
      } catch (e) {
        try {
          this.errors = e.response.data;
          this.pendingRegister = false;
        } catch(e) {
          this.$notify({
            duration: 5000,
            text: this.$t('unknown_error'),
          });
          this.pendingRegister = false;
        }
      }
    },
    changeTypeField(showPassword) {
      this.showPassword = showPassword;
    },
    checkInn() {
      if (this.selectedCountry.inn_check && this.userData.inn) {
        const innMinLength = Math.min(...this.selectedCountry.country_limits.map(x => x.inn_min_length));
        const innMaxLength = Math.max(...this.selectedCountry.country_limits.map(x => x.inn_max_length));
        const inn = String(this.userData.inn).trim();
        if (inn && inn.length >= innMinLength && inn.length <= innMaxLength) {
          this.$axios.$post('/user/check-inn/', this.userData).then((response) => {
            if (response) {
              Object.keys(response).forEach((key) => {
                if (key in this.userData) {
                  this.userData[key] = response[key];
                  this.clearErrors(key);
                }
              });
            }
          });
        }
      }
    },
    searchCity(search, loading) {
      this.citySearchTerm = search;
      if (search?.length) {
        this.$axios.$post('/user/find-city/', {q: search, country: this.userData.country})
            .then((response) => this.cities = response);
      } else {
        this.cities = [];
      }
    },
    onBlurCity() {
      if (!this.cities.includes(this.userData.city)) {
        this.userData.city = this.citySearchTerm;
      }
    },
  },
}
</script>

<i18n lang="yaml">
ru:
  inn_any_country: 'Налоговый номер в стране регистрации'
  register_button: 'Зарегистрироваться'
en:
  inn_any_country: 'Tax number'
  register_button: 'Register'
</i18n>
